import React, { useRef, useState, useEffect, useContext } from "react";
import classes from "./APIPlaygroundComponents.module.scss";
import { OrgIdContext } from "../../store/orgId_context";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const Curl = ({ currentCurl, currentJson, activeApi, connectionKey:importedConenctionKey, id, currentCurlView}) => {
  const curlRef = useRef();
  const [isCurlCopied, setIsCurlCopied] = useState(false);
  const [selectedTab, setSelectedTab] = useState("curl");
  const [jsonRequest, setJsonRequest] = useState(null);
  const [fetchReq, setFetchReq] = useState(null);

  const { connectionKey } = useContext(OrgIdContext);

  const onCopyCurlHandler = () => {
    console.log(curlRef.current.textContent);
    if(currentCurlView && selectedTab==="curl"){
      navigator.clipboard.writeText(currentCurl);
    }else{
      navigator.clipboard.writeText(curlRef.current.textContent);
    }

    setIsCurlCopied(true);
    setTimeout(() => {
      setIsCurlCopied(false);
    }, 1500);
  };

  useEffect(() => {
    let requestBody = `RpcClient.config.headers['Authorization'] = 'IoT ${importedConenctionKey||connectionKey}:EUeInvoices';
    RpcClient.call("Extension.Execute", { extension: "${activeApi}", args: ${JSON.stringify(
      currentJson
    )} }).done(res => {}).post()`;
    // let requestBody = `Axios.post('https://dddinvoices.com/json.rpc', {
    //   jsonrpc: '2.0', method: 'Extension.Execute', params: {
    //     extension: 'EUeInvoices.${activeApi}',
    //     args: ${JSON.stringify(currentJson)}
    //   }, id: ${Math.floor(Math.random() * 100) + 1}
    // }, {
    //   withCredentials: false,
    //   headers: {
    //     Authorization: 'IoT ${connectionKey}:EUeInvoices',
    //     'D3Pro-PreferAuthorizationOverSession': 'True'
    //   }
    // }).then(res => {})`;
    setJsonRequest(requestBody);
    let fetchBody = `fetch(endpoint, {
      method: "POST",
      credentials: "omit",
      headers: {
        "Content-Type": "application/json",
        Authorization: "IoT ${importedConenctionKey||connectionKey}:EUeInvoices",
        "D3Pro-PreferAuthorizationOverSession": "True",
      },
      body: ${JSON.stringify(currentJson)},
    })
      .then((response) => {})
      .catch((error) => {});`;
    setFetchReq(fetchBody);
  }, [activeApi, currentJson, connectionKey, importedConenctionKey]);

  const onChangeRequestHandler = (target) => setSelectedTab(target);

  return (
    <div id={id}>
      <div className={classes["btns-container"]}>
        <button
          onClick={() => onChangeRequestHandler("curl")}
          className={selectedTab === "curl" ? "fw-bold" : ""}
        >
          curl
        </button>
        <button
          onClick={() => onChangeRequestHandler("jsonrpc")}
          className={selectedTab === "jsonrpc" ? "fw-bold" : ""}
        >
          jsonrpc
        </button>
        <OverlayTrigger placement="top" overlay={<Tooltip>{"How to use json.rpc"}</Tooltip>}>
          <NavLink to="/integration-wizard-full" state={{activeLanguage:"Javascript", scrollTo:"how-to"}}><OpenInNewIcon style={{fontSize:"0.9rem"}}/></NavLink>
        </OverlayTrigger>
        
        <button
          onClick={() => onChangeRequestHandler("fetch")}
          className={selectedTab === "fetch" ? "fw-bold" : ""}
        >
          fetch
        </button>
      </div>
      <div className={`${classes["curl-container"]} p-3`}>
        <div className={classes["curl-content"]}>
          <p
            ref={curlRef}
            onClick={onCopyCurlHandler}
            style={{ wordBreak: "break-all" }}
          >
            {selectedTab === "curl" && !currentCurlView && currentCurl}
            {selectedTab === "curl" && currentCurlView && currentCurlView}
            {selectedTab === "jsonrpc" && jsonRequest}
            {selectedTab === "fetch" && fetchReq}
          </p>
          {isCurlCopied && (
            <span className={classes["curl-copied"]}>Copied!</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Curl;
